import filters from './filters/actions'
import list from './list/actions'
import report from './report/actions'
import schedule from './schedule/actions'
import scheduleOrdersPage from './scheduleOrdersPage/actions'
import scheduleDriversPage from './scheduleDriversPage/actions'
import summary from './summary/actions'


export default {
  filters,
  list,
  report,
  schedule,
  scheduleOrdersPage,
  scheduleDriversPage,
  summary,
}
